import { M8StatementDTO } from 'services/production/types';
import { Org } from 'types/orgInfoTypes';
import { Person } from 'types/personTypes';
import { GiroPayment } from 'types/state';
import { createOrg } from 'utils/orgUtils';

export const normalizeM8StatementDTO = (statementDTO: M8StatementDTO) => ({
  toGiroPayment(person: Person, org: Org): GiroPayment {
    return {
      id: statementDTO.id,
      from: {
        unp: statementDTO.unp,
        name: statementDTO.corrName,
      },
      creditedTransaction:
        statementDTO.billedCurrency !== null &&
        statementDTO.billedAmount !== null
          ? {
              currency: statementDTO.billedCurrency,
              amount: statementDTO.billedAmount,
            }
          : null,
      recievedTransaction: {
        currency: statementDTO.amountCurrency,
        amount: statementDTO.amount,
      },
      exchangeRate: statementDTO.exchangeRate,
      comment: statementDTO.purpose,
      clientId: statementDTO.idUser || 0,
      createdAt: statementDTO.createdOn,
      updatedAt: statementDTO.updatedOn,
      person,
      org,
      status: statementDTO.statementStatus,
      recievedAt: statementDTO.acceptDate,
    };
  },
  toPerson(): Person {
    return {
      firstName: statementDTO.firstName || '',
      lastName: statementDTO.lastName || '',
      middleName: statementDTO.middleName || '',
      phone: '',
    };
  },
  toOrg(): Org {
    const org = createOrg();

    if (statementDTO.organization) {
      org.name = statementDTO.organization;
    }

    return org;
  },
});
